export default "__VITE_ASSET__PZNOdjEe__"